<template>
  <div class="container h-100">

    <div class="row">
      <div class="col mt-3">
        <div 
          class="ButtonIcon ButtonIcon--small ButtonIcon--light mx-auto"
          title="Return to Exploring the Wolf"
          @click="updateState(null, 'appWolfmap', 'slideDown')">
          <icon name="home" scale=".85"></icon>
        </div>
      </div>
    </div>

    <transition :name="wolfState.animation" mode="out-in"
    v-on:after-enter="setProp('helpers', 'overflow', 'visible')"
    v-on:before-leave="setProp('helpers', 'overflow', 'hidden')" 
    v-on:after-leave="setProp('helpers', 'overflow', 'hidden')">
      <app-image-slider 
        class="my-3" 
        :id="wolfState.currentDetail.name"
        :imageLs="wolfState.currentDetail.images"
        :parentDir="'explore'"
        :key="generateKey()"/>
    </transition>

  </div>
</template>


<script>
const _ = require('lodash')
import MixinHelper from './../mixins/helper'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/home'
import appImageSlider from './../partials/imageSlider'
export default {
  components: {
    appImageSlider,
    Icon
  },

  mixins: [ MixinHelper ],

  computed: {
    nextDetail () {
      let details = this.wolfContent.mapDetail
      let i = this.getDetailIndex(this.wolfState.currentDetail.name)
      if (i === details.length - 1) {
        return this.wolfContent.mapDetail[0]
      } else {
        i += 1
        return this.wolfContent.mapDetail[i]
      }
    },

    prevDetail () {
      let details = this.wolfContent.mapDetail
      let i = this.getDetailIndex(this.wolfState.currentDetail.name)
      if (i === 0) {
        i = details.length - 1
        return this.wolfContent.mapDetail[i]
      } else {
        i -= 1
        return this.wolfContent.mapDetail[i]
      }
    },

    wolfContent () {
      return this.$store.getters.wolfContent
    },

    wolfState () {
      return this.$store.getters.wolfState
    }
  },

  created () {
    window.addEventListener('wheel', this.scrollHandler)
  },

  beforeDestroy () {
    window.removeEventListener('wheel', this.scrollHandler)
  },

  methods: {
    getDetailIndex (detailName) {
      return _.findIndex(this.wolfContent.mapDetail, { name: detailName })
    },

    scrollHandler (e) {
      this.scrollHome(e)
      // this.scrollNext(e)
    },

    scrollHome (e) {
      if (e.deltaY < 0 && window.scrollY === 0) {
        this.updateState(null, 'appWolfmap', 'slideDown')
      }
    },

    scrollNext (e) {
      // document.body.scrollTop for IE
      const scrollY = document.body.scrollTop || window.pageYOffset
      if (scrollY + window.innerHeight + 50 >= document.body.scrollHeight && e.deltaY > 0) {
        this.updateState(this.nextDetail, 'appWolfDetail', 'slideUp')
      }
    },

    setProp (parent, key, value) {
      let payload = {
        parent: parent,
        key: key,
        value: value
      }
      this.$store.dispatch('setProp', payload)
    },

    updateState (selection, view, animation) {
      let payload = {
        parent: 'wolfmap',
        updates: {
          currentDetail: selection,
          currentView: view,
          animation: animation || 'fade'
        }
      }
      this.$store.dispatch('updateProps', payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/explore/wolf-detail.vue